import { Pipe, PipeTransform } from '@angular/core';

import { KpiTile } from '@dashboards/models/kpi-tile';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';

@Pipe({
  name: 'excludedKpis',
})
export class ExcludedKpisPipe implements PipeTransform {
  transform(kpis: KpiTile[], excludedSteps: WorkflowStepEnumType[] = []): KpiTile[] {
    if (!kpis || excludedSteps.length === 0) return kpis || [];
    return kpis.filter(kpi => !excludedSteps.includes(kpi.kpiGroupId));
  }
}
